export function filterObjectProperties<T>(source: T, keys: (keyof T)[]): Partial<T> {
  return keys.reduce(
    (acc, key) => {
      if (source?.[key] !== undefined) {
        acc[key] = source[key];
      }
      return acc;
    },
    {} as Partial<T>,
  );
}
